import { motion } from "framer-motion";
import { useLang } from "../i18n";

const NUMBER = "33603274610";

export const WhatsAppButton = () => {
  const { lang } = useLang();
  const text = encodeURIComponent(
    lang === "fr"
      ? "Bonjour, je souhaite me renseigner sur la Villa Tutto Passa à Cala Rossa."
      : "Hello, I would like to inquire about Villa Tutto Passa in Cala Rossa."
  );
  return (
    <motion.a
      href={`https://wa.me/${NUMBER}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="whatsapp-btn"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center"
      style={{ boxShadow: "0 10px 30px -8px rgba(37,211,102,0.55)" }}
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
        <path d="M16.04 4C9.42 4 4.05 9.36 4.05 15.97c0 2.11.55 4.17 1.6 5.99L4 28l6.17-1.61a11.97 11.97 0 0 0 5.86 1.53h.01c6.62 0 11.99-5.36 11.99-11.97C28.03 9.36 22.66 4 16.04 4zm0 21.9h-.01a9.94 9.94 0 0 1-5.07-1.39l-.36-.21-3.66.96.98-3.57-.24-.37a9.9 9.9 0 0 1-1.52-5.28c0-5.5 4.47-9.97 9.98-9.97 2.66 0 5.17 1.04 7.05 2.92a9.9 9.9 0 0 1 2.92 7.06c0 5.5-4.48 9.97-9.98 9.97zm5.47-7.47c-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.41-1.48a9.02 9.02 0 0 1-1.66-2.07c-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.62-.93-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.22 5.1 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
      </svg>
    </motion.a>
  );
};
